import React from "react";

const CrclContext = React.createContext();

export default CrclContext;
